import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'discountRule';

const discountRuleService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (data) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(data)}`,
    });
  },

  getDiscount: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getDiscount`,
      data,
    });
  },
};
export default discountRuleService;
